import React from 'react';

import { GroupStyle } from './UpcomingAppointmentGroup.style';

const UpcomingAppointmentGroup: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return <GroupStyle>{children}</GroupStyle>;
};

export default UpcomingAppointmentGroup;
